// extracted by mini-css-extract-plugin
module.exports = {"search":"style_search__3r8tg","wrapper":"style_wrapper__2p6rQ","reset":"style_reset__1D8Qp"};